export var AppName;
(function (AppName) {
    AppName["JuniorHost"] = "junior_host";
    AppName["JuniorMath"] = "junior_math";
    AppName["SeniorMath"] = "senior_math";
    AppName["JuniorABC"] = "junior_abc";
    AppName["JuniorABCUnity"] = "junior_abc_unity";
    AppName["JuniorCode"] = "junior_code";
    AppName["JuniorJaramba"] = "junior_jaramba";
    AppName["SeniorGeo"] = "senior_geo";
    AppName["JuniorUnityHost"] = "junior_unity";
    AppName["JuniorEnglish"] = "junior_english";
    AppName["JuniorPetHabitat"] = "junior_pet_habitat";
})(AppName || (AppName = {}));
//# sourceMappingURL=AppName.js.map